import React from 'react'
import {Select} from "antd"

const {Option} = Select

const MultiSelectSearch = (props) => {
    const {listSelect, name, value, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(value)
    }

    return (
        <div className="FilterSelect">
            <label htmlFor={name}>{label}</label>

            <Select
                placeholder="Please select"
                mode="multiple"
                id={name}
                style={{width: '100%'}}
                defaultValue={value}
                onChange={_handleChangeSelect}
                filterOption={(inputValue, option) =>
                    option.children.join('').toLowerCase().includes(inputValue.toLowerCase())
                }
            >
                {
                    listSelect.map((item, index) => {
                        return <Option
                            value={item.value}
                            key={item.value + '_' + index}
                        >
                            {item.name}{item.fullName ? ` - ${item.fullName}` : ''}
                        </Option>
                    })
                }
            </Select>
        </div>
    )
}

export default MultiSelectSearch
